export interface DmpHlFindPatientParams {
  s_name?: string;             // Au moins 2 caractères
  s_givenName?: string;
  s_birthday?: Date;
  s_city?: string;
  s_postalCode?: string;
  i_sex?: DmpSexEnum;
  i_approxName?: boolean;
  i_approxCity?: boolean;
}

export enum DmpSexEnum {
  'Indéterminé' = 1,
  'Masculin' = 2,
  'Féminin' = 3
}
